import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export default function CopyLinkButton({
  link
}: any) {
  const [linkCopied, setLinkCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div
      className="tooltip tooltip-bottom cursor-pointer"
      data-tip={linkCopied ? "Copied!" : "Copy link"}
      onClick={handleCopyLink}
    >
      <FontAwesomeIcon
        icon={faLink}
        className="ml-1 text-sm"
      />
    </div>
  )
}